module.exports = __webpack_public_path__ + "static/media/quadrant.d97181b7.jpg";